import HomepageChiba from "features/Chiba";

const Chiba = () => {
  return <HomepageChiba />;
};

export default Chiba;
